import { z } from "zod";
import { passwordValidation } from "../../constants/regex";
import { zString } from "./commonSchemaObjects";

export const passwordChangeSchema = z
  .object({
    current_password: zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .max(16, "Password can have maximum 16 characters")
      .regex(passwordValidation, "Password is not in expected format"),
    new_password:  zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .max(16, "Password can have maximum 16 characters")
      .regex(passwordValidation, "Password is not in expected format"),
    confirm_new_password:  zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .max(16, "Password can have maximum 16 characters")
      .regex(passwordValidation, "Password is not in expected format"),
  })
  .refine((data) => data.current_password != data.new_password, {
    message: "Current password and new password cannot be same",
    path: ["new_password"],
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    message: "Passwords don't match",
    path: ["confirm_new_password"],
  });
